import { gql } from '@apollo/client';

export const GET_USER_EBOOKS = gql`
  query getEbooks($offset: Int) {
    ebooks: getUserEbooks(offset: $offset) {
      id
      token
      product {
        id
        name
        blazeId
        image {
          id
          url
        }
      }
    }
  }
`;

export const GET_USER_EBOOK_REDIRECT = gql`
  query getUserEbookRedirect($token: String!) {
    getUserEbookRedirect(token: $token) {
      url
    }
  }
`;
